// ##### 2025-09-11 Komarov
import {
  GET_HOTEL_CONTENT_REQ,
  GET_HOTEL_CONTENT_RES,
  GET_HOTEL_CONTENT_ERR,
} from '../constants';
// ##### 25-02-12 Komarov
import { getPostObject } from '../../helpers/crypto';
// ##### 25-03-28 Komarov
import { postSavingDataClient } from '../../helpers/saveData';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../server/helpers/uniLog';

// ##### 25-04-21 Komarov
export const getHotelContent =
  ({
    id = 0, // hotel's id
    city_id,
    language,
    user_id,
    refpartner,
    sale,
    promocode,
    deviceType,
    company_cipher,
    content_size = 0,
    summary = 0,
  }) =>
    async dispatch => {
      dispatch({ type: GET_HOTEL_CONTENT_REQ });
      const data = {
        // ##### Komarov 2025-05-26
        sale_id: sale || null,
        promocode,
        deviceType,
        company_cipher: company_cipher || '',
        city_id,
        // ##### 25-04-21 Komarov
        hotel_id: id, // hotel's id
        content_size,
        summary,
      };

      const postObject = getPostObject({
        action: 'GetHotelContentAlphaRQ',
        user_id,
        refpartner,
        language,
        // ##### Komarov 2025-05-26
        sale: sale || null,
        data,
      });

      // ##### 25-04-30 Komarov
      uniLog(
        'hotelcontent.js',
        'axios:src/Redux/actions/hotelcontent.js:getHotelContent, url:',
        postObject.url
      );

      // ##### 25-03-28 Komarov: запрашиваем у Сервера Сайта сохранение данных для запроса с текущими параметрами
      await postSavingDataClient({
        postObject,
        typeRes: GET_HOTEL_CONTENT_RES,
        typeErr: GET_HOTEL_CONTENT_ERR,
        dispatch,
      });
    };
